import keyMirror from "keymirror";

const ToasterActionNames = keyMirror({
    TOAST_DASH_MESSAGE: null,
    TOAST_DASH_CLEAR: null
});

export default ToasterActionNames;
